<template>
  <div v-if="$_get(event, 'id')" class="pa-4">
    <div class="d-flex justify-space-between">
      <div>&nbsp;</div>
      <!-- <Breadcrumbs
        :headline="$_get(event, 'title', 'Sự kiện')"
        :link="[{text: 'Sự kiện', href: '../events'}, {text: 'Chi tiết sự kiện'}]"
      /> -->
      <div class="d-flex flex-column">
        <v-btn color="primary" outlined @click="togglePublish">{{ isPublishedText }}</v-btn>
        <v-btn color="primary" outlined @click="toggleRegister" class="mt-2">{{ isOpenRegistrationText }}</v-btn>
      </div>
    </div>

    <div class="mt-6">
      <EventProfile />
      <EventTabs />
    </div>

    <div v-if="isAdmin" class="pa-4 d-flex justify-center align-center mt-6">
      <div class="text-center">
        <div class="mb-2 text-uppercase text-caption">
          Sự kiện chỉ có thể được xoá khi đã ngừng xuất bản và đóng đăng ký
        </div>
        <v-btn outlined color="error" @click="removeEvent" :disabled="isPublished || isOpenRegistration">
          <v-icon left>delete</v-icon>Xoá sự kiện
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
// import Breadcrumbs from '@/components/layout/Breadcrumbs'
import EventProfile from '@/modules/event/detail/EventProfile'
import EventTabs from '@/modules/event/detail/EventTabs'
import {get} from 'lodash'
export default {
  components: {EventProfile, EventTabs},
  computed: {
    ...mapGetters({
      event: 'events/getItem',
      eventSlots: 'eventSlots/getItems',
      role: 'auth/role'
    }),
    isAdmin() {
      return get(this.role, 'type') === 'manager'
    },
    isPublished() {
      return get(this.event, 'isPublished', false)
    },
    isPublishedText() {
      return this.isPublished ? 'Ngừng xuất bản' : 'Xuất bản'
    },
    isOpenRegistration() {
      return get(this.event, 'isOpenRegistration', false)
    },
    isOpenRegistrationText() {
      return this.isOpenRegistration ? 'Đóng đăng ký' : 'Mở đăng ký'
    }
  },
  async created() {
    const eventId = this.$route.params.id
    await this.fetchOneEvent(eventId)
    await this.fetchEventSlots({event: eventId, _sort: 'index:ASC'})
  },
  methods: {
    ...mapActions({
      fetchOneEvent: 'events/fetchOne',
      fetchEventSlots: 'eventSlots/fetchAll',
      updateEvent: 'events/update',
      remove: 'events/remove'
    }),
    togglePublish() {
      const currentIsPublished = this.event.isPublished
      let title = ''
      let text = ''
      if (currentIsPublished) {
        title = 'Xác nhận "Ngừng xuất bản"'
        text =
          'Thao tác này sẽ khiến cho sự kiện không còn hiển thị với PHHS nữa. Bạn có chắc chắn muốn thực hiện thao tác này?'
      } else {
        title = 'Xác nhận "Xuất bản"'
        text = 'Thao tác này sẽ khiến cho sự kiện hiển thị với PHHS. Bạn có chắc chắn muốn thực hiện thao tác này?'
      }
      this.$dialog.confirm({
        title,
        text,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.updateEvent({id: this.event.id, isPublished: !currentIsPublished})
            this.$alert.success('Chuyển trạng thái hiển thị thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    toggleRegister() {
      const currentIsOpenRegistration = this.event.isOpenRegistration
      let title = ''
      let text = ''
      if (currentIsOpenRegistration) {
        title = 'Xác nhận "Đóng đăng ký"'
        text =
          'Thao tác này sẽ khiến PHHS không thể đăng ký tham gia sự kiện này nữa. Bạn có chắc chắn muốn thực hiện thao tác này?'
      } else {
        title = 'Xác nhận "Mở đăng ký"'
        text =
          'Thao tác này sẽ khiến PHHS có thể đăng ký tham gia sự kiện này. Bạn có chắc chắn muốn thực hiện thao tác này?'
      }
      this.$dialog.confirm({
        title,
        text,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.updateEvent({id: this.event.id, isOpenRegistration: !currentIsOpenRegistration})
            this.$alert.success('Chuyển trạng thái đăng ký thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    async removeEvent() {
      this.$dialog.confirm({
        title: 'Xoá sự kiện',
        text: `Việc xoá sự kiện sẽ <span style="color: red">xoá tất cả các dữ liệu liên quan</span> của khảo sát này (câu hỏi, dữ liệu báo cáo, câu trả lời...) <br>Bạn có muốn xoá khảo sát?`,
        okText: 'Xoá',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.remove(this.$route.params.id)
            this.$alert.success('Xoá thành công')
            this.$router.push('/events')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
